import { BadgeCheck } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

// « Création FAB-MIND-OS »: official items whose APK carries the brand (never on third-party apps).
export const BrandTag = ({ app, testId = "brand-tag" }) => {
  const { t } = useI18n();
  if (!app?.brand_tag || app.developer) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-[var(--gold)] bg-black/40 px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-wide text-[var(--gold-bright)]" data-testid={testId}>
      <BadgeCheck className="h-3.5 w-3.5 shrink-0" /> {t("brand.tag")}
    </span>
  );
};
